import { Phone } from 'lucide-react';

export default function Hero() {
  const handleCall = () => {
    window.location.href = 'tel:+919267633372';
  };

  const handleEnroll = () => {
    window.open('https://docs.google.com/forms/d/e/1FAIpQLSdCRhoQCfF_9QNWPYQ-nPd1UTEWGlL4j7n4XSHVeX-HTE0_-g/viewform?usp=publish-editor', '_blank');
  };

  return (
    <section id="home" className="bg-pink-light min-h-screen flex items-center pt-16 sm:pt-20 lg:pt-24">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 w-full">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 lg:gap-12 items-center">
          {/* Left Content */}
          <div className="space-y-2 md:space-y-2 slide-in-up">
            <div className="space-y-0">
              <p className="text-lg sm:text-xl text-purple-primary font-semibold leading-relaxed">
                After School Program
              </p>
              <img src={require('../Logo.png')} alt="Kinder Heaven logo" className="w-68 sm:w-88 h-auto mt-0 mb-0" />
            </div>

            <div className="space-y-1">
              <p className="text-base sm:text-lg text-gray-700 leading-relaxed font-medium">
                We support all parents by ensuring children complete their homework, revise concepts, and develop essential skills in a guided and caring environment.
              </p>
            </div>

            {/* CTA Buttons */}
            <div className="flex flex-col sm:flex-row gap-4 pt-2">
              <button onClick={handleEnroll} className="bg-purple-primary text-white px-6 sm:px-8 py-3 sm:py-4 rounded-2xl font-semibold text-base sm:text-lg hover:shadow-lg transform hover:scale-105 transition-all duration-300 flex items-center justify-center gap-2">
                Enroll Now
              </button>
              <button onClick={handleCall} className="bg-purple-primary text-white px-6 sm:px-8 py-3 sm:py-4 rounded-2xl font-semibold text-base sm:text-lg hover:shadow-lg transform hover:scale-105 transition-all duration-300 flex items-center justify-center gap-2">
                <Phone size={20} />
                Call Now
              </button>
            </div>
          </div>

          {/* Right Image */}
          <div className="flex justify-center mt-8 md:mt-0">
            <div className="relative w-full max-w-sm md:max-w-md">
              {/* Decorative circles */}
              <div className="absolute inset-0 bg-gradient-to-br from-purple-primary/20 to-pink-light/20 rounded-full blur-3xl"></div>
              
              {/* Main illustration placeholder */}
              <div className="relative bg-white rounded-3xl p-4 sm:p-8 md:p-12 shadow-soft float-animation">
                <img
                  src="/gallery/child-hero.png"
                  alt="Hero Section Image"
                  className="w-full h-auto rounded-2xl object-contain"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
